// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-tooltip__root {
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;
}
.onboarding-tooltip__svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: all;
}
.onboarding-tooltip__box {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
  width: 354px;
  z-index: 10000;
  pointer-events: all;
  box-sizing: border-box;
}
.onboarding-tooltip__arrow {
  position: absolute;
  width: 0;
  height: 0;
}
.onboarding-tooltip__arrow--top {
  bottom: -9px;
  left: 50%;
  margin-left: -9px;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-top: 9px solid #fff;
}
.onboarding-tooltip__arrow--bottom {
  top: -9px;
  left: 50%;
  margin-left: -9px;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid #fff;
}
.onboarding-tooltip__arrow--left {
  right: -9px;
  top: 50%;
  margin-top: -9px;
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-left: 9px solid #fff;
}
.onboarding-tooltip__arrow--right {
  left: -9px;
  top: 50%;
  margin-top: -9px;
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-right: 9px solid #fff;
}
.onboarding-tooltip__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid var(--sebrae-light-gray4);
}
.onboarding-tooltip__title {
  font-weight: 700;
  font-size: 19px;
  color: var(--sebrae-gray);
}
.onboarding-tooltip__close {
  background: none;
  border: none;
  cursor: pointer;
  color: #9aa0b0;
  font-size: 14px;
  line-height: 1;
  padding: 0;
  pointer-events: all;
}
.onboarding-tooltip__content {
  font-size: 16px;
  color: var(--sebrae-gray);
  line-height: 23.3px;
  padding: 24px 16px;
}
.onboarding-tooltip__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px 16px;
}
.onboarding-tooltip__step-count {
  font-size: 13px;
  color: var(--sebrae-gray);
}
.onboarding-tooltip__footer-btns {
  display: flex;
  gap: 16px;
}
.onboarding-tooltip__footer-btns button {
  padding: 8px 12px;
  height: 32px;
  min-height: unset;
}
.onboarding-tooltip__footer-btns button span {
  font-weight: 400;
  font-size: 13px;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/onboarding-tooltip/index.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,oBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AADJ;AAIE;EACE,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAHJ;AAKI;EACE,YAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAAA;EACA,mCAAA;EACA,0BAAA;AAHN;AAMI;EACE,SAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AAJN;AAOI;EACE,WAAA;EACA,QAAA;EACA,gBAAA;EACA,iCAAA;EACA,oCAAA;EACA,2BAAA;AALN;AAQI;EACE,UAAA;EACA,QAAA;EACA,gBAAA;EACA,iCAAA;EACA,oCAAA;EACA,4BAAA;AANN;AAUE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kDAAA;AARJ;AAWE;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;AATJ;AAYE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;AAVJ;AAaE;EACE,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAXJ;AAcE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAZJ;AAeE;EACE,eAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,SAAA;AAdJ;AAgBI;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;AAdN;AAgBM;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAdR","sourcesContent":[".onboarding-tooltip {\n  &__root {\n    position: fixed;\n    inset: 0;\n    z-index: 9999;\n    pointer-events: none;\n  }\n\n  &__svg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: all;\n  }\n\n  &__box {\n    background: #fff;\n    border-radius: 4px;\n    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);\n    width: 354px;\n    z-index: 10000;\n    pointer-events: all;\n    box-sizing: border-box;\n  }\n\n  &__arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n\n    &--top {\n      bottom: -9px;\n      left: 50%;\n      margin-left: -9px;\n      border-left: 9px solid transparent;\n      border-right: 9px solid transparent;\n      border-top: 9px solid #fff;\n    }\n\n    &--bottom {\n      top: -9px;\n      left: 50%;\n      margin-left: -9px;\n      border-left: 9px solid transparent;\n      border-right: 9px solid transparent;\n      border-bottom: 9px solid #fff;\n    }\n\n    &--left {\n      right: -9px;\n      top: 50%;\n      margin-top: -9px;\n      border-top: 9px solid transparent;\n      border-bottom: 9px solid transparent;\n      border-left: 9px solid #fff;\n    }\n\n    &--right {\n      left: -9px;\n      top: 50%;\n      margin-top: -9px;\n      border-top: 9px solid transparent;\n      border-bottom: 9px solid transparent;\n      border-right: 9px solid #fff;\n    }\n  }\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 16px;\n    border-bottom: 1px solid var(--sebrae-light-gray4);\n  }\n\n  &__title {\n    font-weight: 700;\n    font-size: 19px;\n    color: var(--sebrae-gray);\n  }\n\n  &__close {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #9aa0b0;\n    font-size: 14px;\n    line-height: 1;\n    padding: 0;\n    pointer-events: all;\n  }\n\n  &__content {\n    font-size: 16px;\n    color: var(--sebrae-gray);\n    line-height: 23.3px;\n    padding: 24px 16px;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0px 16px 16px;\n  }\n\n  &__step-count {\n    font-size: 13px;\n    color: var(--sebrae-gray);\n  }\n\n  &__footer-btns {\n    display: flex;\n    gap: 16px;\n\n    button {\n      padding: 8px 12px;\n      height: 32px;\n      min-height: unset;\n\n      span {\n        font-weight: 400;\n        font-size: 13px;\n        line-height: 1;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
